export default "__VITE_ASSET__DYDEMDH5__"